export interface Product {
  sku: string;
  id: string;
  name: string;
  brand: string;
  currency: string;
  imageUrl: string;
  images: string[];
  categoryId: number;
  subcategoryId: number | null;
  gender: string;
  condition: string;
  year: number;
  color: string;
  favorites: number;
  description: string;
  createdAt: string;
  updatedAt: string;
}

// 🆕 Опция доступности товара (в наличии, со склада, из-за границы)
export interface AvailabilityOption {
  type: 'in_stock' | 'warehouse' | 'abroad';
  label: string;
  quantity: number;
  reservedQuantity: number;
  availableQuantity: number;
  price: number;
  discount: number | null;
  deliveryDays: number;
  enabled: boolean;
}

export interface ProductSize {
  id?: number;
  sku?: string;
  us: string;
  
  // Старые поля (для обратной совместимости)
  price: number;
  discount: number | null;
  inStock: boolean;
  quantity: number;           // Количество в наличии (0+)
  isPreOrder: boolean;        // Товар под заказ
  deliveryDays?: number;      // Срок доставки в днях
  
  // 🆕 Новая система множественных способов доставки
  availabilityOptions?: AvailabilityOption[];
  
  createdAt?: string;
  updatedAt?: string;
}

export interface ProductWithSizes extends Product {
  sizes: ProductSize[];
}

export interface CreateProductDto {
  sku: string;
  id: string;
  name: string;
  brand: string;
  currency: string;
  imageUrl: string;
  images: string[];
  categoryId: number;
  subcategoryId: number | null;
  gender: string;
  condition: string;
  year: number;
  color: string;
  description: string;
  sizes: Omit<ProductSize, 'id' | 'sku' | 'createdAt' | 'updatedAt'>[];
}

export interface UpdateProductDto {
  name?: string;
  brand?: string;
  price?: number;
  imageUrl?: string;
  images?: string[];
  sizes?: Omit<ProductSize, 'id' | 'sku' | 'createdAt' | 'updatedAt'>[];
  color?: string;
  gender?: string;
  condition?: string;
  year?: number;
  description?: string;
  categoryId?: number;
  subcategoryId?: number | null;
  [key: string]: any;
}

export interface ProductsResponse {
  products: Product[];
  total: number;
  limit: number;
  offset: number;
}

export interface ProductResponse {
  product: Product;
  sizes: ProductSize[];
  category?: {
    id: number;
    slug: string;
    nameRu: string;
    nameEn: string;
  };
  subcategory?: {
    id: number;
    slug: string;
    nameRu: string;
  };
}

export interface BrandsResponse {
  brands: string[];
  total: number;
}

export interface NextIdResponse {
  nextId: number;
}

// 🆕 Константы для типов доступности
export const AVAILABILITY_TYPES = {
  IN_STOCK: 'in_stock' as const,
  WAREHOUSE: 'warehouse' as const,
  ABROAD: 'abroad' as const,
};

export const AVAILABILITY_LABELS = {
  [AVAILABILITY_TYPES.IN_STOCK]: 'В наличии',
  [AVAILABILITY_TYPES.WAREHOUSE]: 'Со склада (2-3 дня)',
  [AVAILABILITY_TYPES.ABROAD]: 'Из-за границы',
};

export const AVAILABILITY_DEFAULT_DAYS = {
  [AVAILABILITY_TYPES.IN_STOCK]: 0,
  [AVAILABILITY_TYPES.WAREHOUSE]: 3,
  [AVAILABILITY_TYPES.ABROAD]: 14,
};

// 🆕 Создание пустой опции доступности
export const createEmptyAvailabilityOption = (type: 'in_stock' | 'warehouse' | 'abroad'): AvailabilityOption => ({
  type,
  label: AVAILABILITY_LABELS[type],
  quantity: 0,
  reservedQuantity: 0,
  availableQuantity: 0,
  price: 0,
  discount: null,
  deliveryDays: AVAILABILITY_DEFAULT_DAYS[type],
  enabled: false,
});

